class e {
  constructor() {
    this.decimalSeparator = ".";
  }
  zipcode(t) {
  }
}
export {
  e as default
};
